import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { AppConfig } from './app/model/config';
import { enableProdMode } from '@angular/core';
import { PublicClientApplication, IPublicClientApplication, LogLevel, BrowserCacheLocation, InteractionType } from '@azure/msal-browser';
import { MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, MsalInterceptorConfiguration, MsalGuardConfiguration } from '@azure/msal-angular';


let APP_CONFIG_MAIN: AppConfig;
const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;


fetch('assets/config/config.json').then(response => {
  return response.json();
})
  .then(envResponse => {
    const t = new AppConfig();
    APP_CONFIG_MAIN = Object.assign(t, envResponse);

    const providers = [      
      { provide: AppConfig, useValue: APP_CONFIG_MAIN },
      {
        provide: MSAL_INSTANCE,
        useFactory: MSALInstanceFactory
      },
      {
        provide: MSAL_GUARD_CONFIG,
        useFactory: MSALGuardConfigFactory
      },
      {
        provide: MSAL_INTERCEPTOR_CONFIG,
        useFactory: MSALInterceptorConfigFactory
      },
    ];
    if (t.production_environment === false) {
      enableProdMode();
    }

    platformBrowserDynamic(providers).bootstrapModule(AppModule)
      .catch(err => console.log(err));
  });


export function loggerCallback(logLevel: LogLevel, message: string) {
  console.log(message);
}

function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: APP_CONFIG_MAIN.msal_clientID,
      authority: APP_CONFIG_MAIN.msal_authority,
      redirectUri: APP_CONFIG_MAIN.msal_redirectUri,
      postLogoutRedirectUri: APP_CONFIG_MAIN.msal_postLogoutRedirectUri,
      navigateToLoginRequestUrl: true
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE, // set to true for IE 11
    },
    system: {
      loggerOptions: {
        loggerCallback,
        logLevel: LogLevel.Error,
        piiLoggingEnabled: false
      }
    }
  });
}


function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  // unauthenticated scope
  protectedResourceMap.set(APP_CONFIG_MAIN.msal_protectedResource + "/checkinuser", null);
  // authenticated scope
  protectedResourceMap.set(APP_CONFIG_MAIN.msal_protectedResource, [APP_CONFIG_MAIN.apiScope]);
  

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    loginFailedRoute: '/authorizeerror'
  };
}
